import React, { useState, useEffect } from "react";
import NavbarDashboard from "../../../components/Navbar/NavbarDashboard";
import { Link } from "react-router-dom";
import fundamentals_icon from "../../../assets/images/icon_fundamentals.png";
import "../../../styles/style_label.css";
import LinearProgress from "@mui/joy/LinearProgress";
import Typography from "@mui/joy/Typography";
import { firebase, doc, db, getDoc, auth } from "../../../firebase";
import "firebase/compat/firestore";
import { IoChevronBackOutline } from "react-icons/io5";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../../../styles/tabs.css";

function Progress() {
  let nbsp = "\u00a0";

  // Step 2: Initialize a state variable
  const [quizFinishedValueLicensing, setQuizFinishedValue] = useState(0);
  const completedStyle = { color: "green" };
  const notStartedStyle = { color: "red" };

  const getQuizFinishedStatusLicensing = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "licensing", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  useEffect(() => {
    getQuizFinishedStatusLicensing();
  }, []); //

  const quizStatusTextLicensing =
    quizFinishedValueLicensing === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const [activeTab, setActiveTab] = useState(1); // Default to the first tab

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="container-dashboard">
      <NavbarDashboard />

      <div className="container-main-contents">
        <div className="container-main-header">
          <div className="container-main-header-title">
            <Link class="back-button" to={"/"}>
              <IoChevronBackOutline />
            </Link>
            <h1>FINES, PENALTIES & VIOLATIONS</h1>
          </div>

          <p>
          Understanding fines, penalties, and violations associated with road rules is crucial for fostering responsible driving behavior and ensuring public safety. Awareness of the consequences serves as a deterrent, encouraging compliance with traffic regulations and reducing the risk of accidents. This knowledge promotes a sense of accountability among drivers, contributing to a culture of responsible citizenship on the road. Additionally, it aids in informed decision-making, prompting individuals to make safer choices while driving.
          </p>
        </div>
        <div className="lesson-content">
          <Tabs>
            <TabList className="tab-selector">
              <Tab
                onClick={() => handleTabClick(1)}
                className={activeTab === 1 ? "active-tab tab-ind" : "tab-ind"}
              >
                <h1>Basics</h1>
              </Tab>
            </TabList>

            {activeTab === 1 && (
              <div className="lesson-selection">
                <div className="lesson-selection-card">
                  <h4>Licensing</h4>
                  <Link to="/fpv_licensing">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextLicensing}</p>
                </div>
              </div>
            )}

            {activeTab === 2 && (
              <div className="lesson-selection">
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Test</h4>
                  <p className="start-learning">Start Learning</p>
                </div>
              </div>
            )}

            {activeTab === 3 && (
              <div className="lesson-selection">
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Test</h4>
                  <p className="start-learning">Start Learning</p>
                </div>
              </div>
            )}

            {/* <TabPanel>
              <h2>Basics Page</h2>
            </TabPanel>
            <TabPanel>
              <h2>Additinals Page</h2>
            </TabPanel>
            <TabPanel>
              <h2>Quizzes Page</h2>
            </TabPanel> */}
          </Tabs>
        </div>
      </div>
    </div>
  );
}
export default Progress;
